/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ReferenceEditing from './referenceEditing';
import ReferenceUi from './referenceUi';

export default class Reference extends Plugin {
	static get requires() {
		return [ ReferenceEditing, ReferenceUi ];
	}
}